let currentFlavor;
const featureSet = new Set();
const loaders = new Map();
export var Flavor;
(function (Flavor) {
    Flavor.MARINA = 'marina';
    Flavor.LIGHTHOUSE = 'lighthouse';
    function setFlavor(flavor, features = []) {
        if (currentFlavor) {
            throw new Error('Cannot re-set flavor. Already set as ' + currentFlavor);
        }
        currentFlavor = flavor;
        features.forEach(feature => featureSet.add(feature));
    }
    Flavor.setFlavor = setFlavor;
    function addFeature(feature) {
        featureSet.add(feature);
    }
    Flavor.addFeature = addFeature;
    function hasFeature(feature) {
        return featureSet.has(feature);
    }
    Flavor.hasFeature = hasFeature;
    function addLoader(loader) {
        if (!currentFlavor) {
            throw new Error('Cannot add loaders when current feature is not yet set');
        }
        loaders.set(loader.feature, loader);
    }
    Flavor.addLoader = addLoader;
    function getLoaders() {
        if (!currentFlavor) {
            throw new Error('No loaders when current feature is not yet set');
        }
        return Array.from(loaders.values());
    }
    Flavor.getLoaders = getLoaders;
})(Flavor || (Flavor = {}));
//# sourceMappingURL=Flavor.js.map